/* eslint-disable jsdoc/require-returns-type */
/* eslint-disable jsdoc/require-returns-description */
/* eslint-disable jsdoc/require-param-type */
/* eslint-disable jsdoc/require-param-description */
/* eslint-disable jsdoc/require-returns */
/**
 *
 */
declare global {
    interface Window {
        AngularAppConfig: any;
    }
}

interface AppConfig {
    [key: string]: string;
}
/**
 *
 */
function getAppConfigFromWindowObject(): unknown {
    return window.AngularAppConfig || {};
}

/**
 *
 * @param key
 */
export function getAppConfig(key: string): string {
    const config = getAppConfigFromWindowObject();

    if (isAppConfig(config)) {
        return config[key] || '';
    }
    return '';
}

/**
 *
 * @param key
 * @param value
 */
export function setAppConfig(key: string, value: string): void {
    const config = getAppConfigFromWindowObject();
    
    // Type-check the config object before accessing it
    if (isAppConfig(config)) {
        config[key] = value;
    } else {
        console.error('Invalid config object');
    }
}

/**
 * 
 * @param config 
 * @returns 
 */
export function isAppConfig(config: unknown): config is AppConfig {
    return typeof config === 'object' && config !== null && !Array.isArray(config);
}
